import React, { useState } from "react";
import "./Order_summery_holder.css";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login_Modal from "../../../common-components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import { appSetup } from "../../../../features/master/masterSlice";

function Order_summery_holder({ data, instock }) {
  const navigate = useNavigate();

  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [error, setError] = useState("");
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const handleClick = () => {
    if (instock) {
      setError("Item is out of stock. Please try later.");
      return; // Don't proceed
    }

    if (data.data?.length > 0) {
      if (isSignIn) {
        navigate("/proceed-to-Checkout");
      } else {
        setShowLoginModal(true);
        //  navigate("/proceed-to-Checkout");
      }
    } else {
      setError("Your cart is currently empty. Please add items to proceed.");
    }
  };

  const getVariantPrice = (item) => {
    if (item?.Triple_Variant?.price) {
      return parseFloat(item.Triple_Variant.price);
    }

    if (item?.Double_Variant?.price) {
      return parseFloat(item.Double_Variant.price);
    }

    if (item?.Product_Variant?.price) {
      return parseFloat(item.Product_Variant.price);
    }

    return 0;
  };

  const getVariantMrp = (item) => {
    if (item?.Triple_Variant?.mrp) {
      return parseFloat(item.Triple_Variant.mrp);
    }

    if (item?.Double_Variant?.mrp) {
      return parseFloat(item.Double_Variant.mrp);
    }

    if (item?.Product_Variant?.mrp) {
      return parseFloat(item.Product_Variant.mrp);
    }

    return 0;
  };

  const app_setup = useSelector((state) => state.master.app_setup);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  // const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  // let total_amount = 0;
  // let total_tax = 0;

  // if (Array.isArray(data?.data)) {
  //   total_amount = data.data.reduce((acc, item) => {
  //     // const tax_percentage = parseFloat(item?.Product?.tax_percentage || 0);\

  //     const tax_percentage = Number(app_setup?.tax_percentage || 0);
  //     const price = getVariantPrice(item);

  //     const qty = Number(item?.quantity || 0);

  //     const lineTotal = price * qty;

  //     total_tax += lineTotal * (tax_percentage / 100);

  //     return acc + lineTotal;
  //   }, 0);
  // }

  // const grandTotal = total_amount + total_tax;

  /* New offer discount calculate */
  let total_amount = 0;
  let total_tax = 0;
  let total_offer_discount = 0;

  if (Array.isArray(data?.data)) {
    // Calculate total quantity
    const totalQuantity = data.data.reduce(
      (sum, item) => sum + Number(item?.quantity || 0),
      0,
    );

    /*
     * BUY 1 GET 1
     */
    if (app_setup?.buy_one_status === true && totalQuantity >= 2) {
      const buyOneProducts = [];

      data.data.forEach((item, index) => {
        const price = getVariantPrice(item);
        const quantity = Number(item?.quantity || 0);

        for (let i = 0; i < quantity; i++) {
          buyOneProducts.push({
            index,
            price,
          });
        }
      });

      // Highest price first
      buyOneProducts.sort((a, b) => b.price - a.price);

      const discountByProduct = {};

      // Buy 1 Get 1
      // Highest price = paid
      // Second highest = free
      for (let i = 0; i + 1 < buyOneProducts.length; i += 2) {
        const freeProduct = buyOneProducts[i + 1];

        if (!discountByProduct[freeProduct.index]) {
          discountByProduct[freeProduct.index] = 0;
        }

        discountByProduct[freeProduct.index] += freeProduct.price;
      }

      // Odd product discount
      if (buyOneProducts.length % 2 !== 0) {
        const lastProduct = buyOneProducts[buyOneProducts.length - 1];

        let oddProductDiscount = Number(app_setup?.odd_product_discount || 0);

        oddProductDiscount = Math.max(0, Math.min(100, oddProductDiscount));

        if (!discountByProduct[lastProduct.index]) {
          discountByProduct[lastProduct.index] = 0;
        }

        discountByProduct[lastProduct.index] +=
          (lastProduct.price * oddProductDiscount) / 100;
      }

      data.data.forEach((item, index) => {
        const price = getVariantPrice(item);
        const qty = Number(item?.quantity || 0);

        const lineTotal = price * qty;

        const offerDiscount = Number(
          (discountByProduct[index] || 0).toFixed(2),
        );

        total_amount += lineTotal;
        total_offer_discount += offerDiscount;

        const tax_percentage = Number(app_setup?.tax_percentage || 0);

        const taxBase = lineTotal - offerDiscount;

        total_tax += taxBase * (tax_percentage / 100);
      });
    } else {
      /*
       * NORMAL DISCOUNT
       *
       * Product -> Category -> Global
       *
       * This is used when:
       * 1. buy_one_status = false
       * 2. buy_one_status = true but only 1 item is ordered
       */
      const globalDiscount = Number(app_setup?.global_discount || 0);

      data.data.forEach((item) => {
        const price = getVariantPrice(item);
        const qty = Number(item?.quantity || 0);

        const lineTotal = price * qty;

        let discountPercentage = 0;

        // 1. Product discount
        if (
          item?.Product?.prod_discount !== null &&
          item?.Product?.prod_discount !== undefined &&
          item?.Product?.prod_discount !== "" &&
          !isNaN(Number(item?.Product?.prod_discount))
        ) {
          discountPercentage = Number(item.Product.prod_discount);
        }

        // 2. Category discount
        else if (
          item?.Product?.p_category?.cat_discount !== null &&
          item?.Product?.p_category?.cat_discount !== undefined &&
          item?.Product?.p_category?.cat_discount !== "" &&
          !isNaN(Number(item?.Product?.p_category?.cat_discount))
        ) {
          discountPercentage = Number(item.Product.p_category.cat_discount);
        }

        // 3. Global discount
        else if (!isNaN(globalDiscount)) {
          discountPercentage = globalDiscount;
        }

        discountPercentage = Math.max(0, Math.min(100, discountPercentage));

        const offerDiscount = (lineTotal * discountPercentage) / 100;

        total_amount += lineTotal;
        total_offer_discount += offerDiscount;

        const tax_percentage = Number(app_setup?.tax_percentage || 0);

        const taxBase = lineTotal - offerDiscount;

        total_tax += taxBase * (tax_percentage / 100);
      });
    }
  }

  const discountedSubtotal = total_amount - total_offer_discount;

  const grandTotal = discountedSubtotal + total_tax;

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const getOfferDetails = () => {
    if (!Array.isArray(data?.data) || data.data.length === 0) {
      return [];
    }

    const totalQuantity = data.data.reduce(
      (sum, item) => sum + Number(item?.quantity || 0),
      0,
    );

    // BUY 1 GET 1
    if (app_setup?.buy_one_status === true && totalQuantity >= 2) {
      const buyOneProducts = [];

      data.data.forEach((item, index) => {
        const price = getVariantPrice(item);
        const quantity = Number(item?.quantity || 0);

        for (let i = 0; i < quantity; i++) {
          buyOneProducts.push({
            index,
            price: Number(price || 0),
          });
        }
      });

      // Same sorting as backend
      buyOneProducts.sort((a, b) => b.price - a.price);

      const discountByProduct = {};
      const totalProducts = buyOneProducts.length;
      const freeProductCount = Math.floor(totalProducts / 2);

      // Same logic as backend
      if (totalProducts % 2 === 0) {
        // Even quantity:
        // Highest half = paid
        // Lowest half = FREE
        const freeStartIndex = totalProducts - freeProductCount;

        for (let i = freeStartIndex; i < totalProducts; i++) {
          const freeProduct = buyOneProducts[i];

          if (!discountByProduct[freeProduct.index]) {
            discountByProduct[freeProduct.index] = 0;
          }

          discountByProduct[freeProduct.index] += freeProduct.price;
        }
      } else {
        // Odd quantity:
        // Highest products = paid
        // Next half = FREE
        // Last/lowest product = odd product discount

        const freeStartIndex = totalProducts - freeProductCount - 1;

        const freeEndIndex = totalProducts - 1;

        for (let i = freeStartIndex; i < freeEndIndex; i++) {
          const freeProduct = buyOneProducts[i];

          if (!discountByProduct[freeProduct.index]) {
            discountByProduct[freeProduct.index] = 0;
          }

          discountByProduct[freeProduct.index] += freeProduct.price;
        }

        // Odd product discount
        const oddProduct = buyOneProducts[totalProducts - 1];

        let oddProductDiscount = Number(app_setup?.odd_product_discount || 0);

        oddProductDiscount = Math.max(0, Math.min(100, oddProductDiscount));

        if (!discountByProduct[oddProduct.index]) {
          discountByProduct[oddProduct.index] = 0;
        }

        discountByProduct[oddProduct.index] +=
          (oddProduct.price * oddProductDiscount) / 100;
      }

      // Apply calculated discount
      data.data.forEach((item, index) => {
        const offerDiscount = Number(discountByProduct[index] || 0);

        // use your existing subtotal/total calculation here
        // wherever discountByProduct[index] was previously used
      });
    }

    // NORMAL DISCOUNT
    const globalDiscount = Number(app_setup?.global_discount || 0);

    const offers = [];

    data.data.forEach((item) => {
      let discountPercentage = 0;
      let discountType = "";

      // Product Discount
      if (
        item?.Product?.prod_discount !== null &&
        item?.Product?.prod_discount !== undefined &&
        item?.Product?.prod_discount !== "" &&
        !isNaN(Number(item?.Product?.prod_discount))
      ) {
        discountPercentage = Number(item.Product.prod_discount);
        discountType = "Product Discount";
      }

      // Category Discount
      else if (
        item?.Product?.p_category?.cat_discount !== null &&
        item?.Product?.p_category?.cat_discount !== undefined &&
        item?.Product?.p_category?.cat_discount !== "" &&
        !isNaN(Number(item?.Product?.p_category?.cat_discount))
      ) {
        discountPercentage = Number(item.Product.p_category.cat_discount);
        discountType = "Category Discount";
      }

      // Global Discount
      else if (!isNaN(globalDiscount) && globalDiscount > 0) {
        discountPercentage = globalDiscount;
        discountType = "Flat Discount";
      }

      if (discountPercentage > 0 && discountType) {
        const exists = offers.some(
          (offer) =>
            offer.type === discountType &&
            offer.percentage === discountPercentage,
        );

        if (!exists) {
          offers.push({
            type: discountType,
            percentage: discountPercentage,
          });
        }
      }
    });

    return offers;
  };

  const offerDetails = getOfferDetails();

  return (
    <>
      {data?.data?.length > 0 && (
        <section className="Order_summery_holder theme_bg_ternary_colour">
          <div className="heading_holder">
            <h6>Order Summary</h6>
          </div>
          <div className="Order_summery_table">
            <div className="table-responsive">
              <Table>
                <tbody>
                  <tr>
                    <td>SubTotal</td>
                    <td className="text-end">
                      {symbol} {Number(total_amount).toFixed(2)}
                    </td>
                  </tr>

                  <tr>
                    <td>Offer Discount</td>
                    <td className="text-end">
                      <span className="inner_red_text">-</span>
                      {symbol} {Number(total_offer_discount).toFixed(2)}
                    </td>
                  </tr>

                  {/* <tr>
                    <td>
                      Offer Discount
                      {offerDetails.length > 0 && (
                        <div className="offer_details_text">
                          {offerDetails.map((offer, index) => (
                            <div key={index}>
                              <small>
                                {offer.type}
                                {offer.percentage !== null &&
                                  ` (${Number(offer.percentage).toFixed(2)}%)`}
                              </small>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>

                    <td className="text-end">
                      <span className="inner_red_text">-</span>
                      {symbol} {Number(total_offer_discount).toFixed(2)}
                    </td>
                  </tr> */}

                  {/* <tr>
                  <td>Discount</td>
                  <td className="text-end">₹ 0</td>
                </tr> */}
                  {/* <tr>
                  <td>Tax</td>
                  <td className="text-end">₹ {Number(total_tax).toFixed(2)}</td>
                </tr> */}
                  {/* <tr>
                  <td>Shipping</td>
                  <td className="text-end">Free</td>
                </tr> */}
                  <tr className="total_tr_holder">
                    <td>
                      <b>Total</b>
                    </td>
                    <td className="text-end">
                      <b>
                        {symbol} {Number(grandTotal).toFixed(2)}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
          <div className="btn_holder ">
            <Green_btn btnText={"Proceed to Checkout"} onClick={handleClick} />

            {/* <section className="Green_btn_holder">
            <Button className="Green_btn" onClick={handleClick}> 
              &nbsp;Proceed to Checkout
            </Button>
          </section> */}
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}
            {/* <Green_btn btnText={"Proceed to Checkout"} onClick={handleClick} /> */}
          </div>
        </section>
      )}
      <Login_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        show={showSetPassModal}
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successfully!"
      />
    </>
  );
}

export default Order_summery_holder;
